var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6719 12.8906L11.3906 9.60938C12.1289 8.51562 12.5117 7.14844 12.3203 5.67188C11.9648 3.15625 9.91406 1.13281 7.42578 0.804688C3.70703 0.339844 0.5625 3.48438 1.02734 7.20312C1.35547 9.69141 3.37891 11.7422 5.89453 12.0977C7.37109 12.2891 8.73828 11.9062 9.85938 11.168L13.1133 14.4492C13.5508 14.8594 14.2344 14.8594 14.6719 14.4492C15.082 14.0117 15.082 13.3281 14.6719 12.8906ZM3.16016 6.4375C3.16016 4.52344 4.71875 2.9375 6.66016 2.9375C8.57422 2.9375 10.1602 4.52344 10.1602 6.4375C10.1602 8.37891 8.57422 9.9375 6.66016 9.9375C4.71875 9.9375 3.16016 8.37891 3.16016 6.4375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6fcad33b749bf5ca8c8775b0c3dcafac.svg";
export { ForwardRef as ReactComponent };